import OfflineQueue from './queue/OfflineQueue';
import dataModel from '../models/DataModel';
import DAO from './DAO.js';
import projectsService from '../services/projectsService';

export default class ProjectChartSummaryDAO extends DAO {

  constructor(store) {
    super(store);
    this.OfflineQueue = OfflineQueue;
    this.unsetProjectsSummary = this.unsetProjectsSummary.bind(this);
    this.clearEventHistories = this.clearEventHistories.bind(this);
    this.setFilter = this.setFilter.bind(this);
    this.getFilter = this.getFilter.bind(this);
  }

  setProjectsSummaryAction(projectsSummary){
    return{
      type: 'PROJECT_SUMMARY_SET',
      projectsSummary: projectsSummary,
    };
  }

  unsetProjectsSummaryAction(id){
    return{
      type: 'PROJECT_SUMMARY_UNSET',
      id,
    };
  }

  clearEventHistoriesAction() {
    return {
      type: 'PROJECT_SUMMARY_CLEAR',
    };
  }

  findProjectsSummary(id) {
    return this.stateTree.new_projects[id];
  }

  setFilter(filter) {
    this._filter = filter;
    if (this._filter) {
      this._filter.company_id = localStorage.current_company_id;
    }
  }

  getFilter() {
    if (!this._filter) {
      // TODO: a better solution would be nice - this is in place because redux-persist does not rehydrate the store until after the constructor is called 
      const filterFromStore = this.stateTree.new_projects && this.stateTree.new_projects.status_summary ? this.stateTree.new_projects.status_summary._filter : {};
      this.setFilter(filterFromStore);
    }   
    if (this._filter.company_id && this._filter.company_id != localStorage.current_company_id) {
      this.setFilter({});
    }
    return this._filter;
  }

  setProjectsSummary(summaryData) {
    this.store.dispatch(this.setProjectsSummaryAction(summaryData));
    return this.findProjectsSummary(summaryData.id);
  }

  unsetProjectsSummary(id) {
    this.store.dispatch(this.unsetProjectsSummaryAction(id));
  }

  clearEventHistories() {
    this.store.dispatch(this.clearEventHistoriesAction());
  }

  async getProjectsSummary(company) {
    //dataModel.inProgress = 120000
    let options = {};
    let marketIds = await dataModel.usersDAO.getEditorUserMarkets(this.userId ? this.userId : dataModel.usersDAO.currentUser.id);
    options.marketIds = marketIds;

    const response = await projectsService.getProjectsSummary(company.id, this._filter, options);
    //dataModel.inProgress = 0
    if (!response || response.error || !response.status_summary){
      dataModel.displayHTTPError('Getting the project summary', response.error, false);
      return response;
    }
    else {
      const summaryObjectForStore = { entries: response.status_summary, lastUpdated: response.last_updated, _filter: this._filter };
      this.setProjectsSummary(summaryObjectForStore);
      return summaryObjectForStore;
    }
  }

  expandProjectsSummary(id) {
    // TODO: any normalization
    return Object.assign({}, this.findProjectsSummary(id));
  }

  clearState(options) {
    // getFilter handles all the checks we need...
  }
}



// WEBPACK FOOTER //
// ./src/dao/ProjectChartSummaryDAO.js